module.exports = __webpack_public_path__ + "static/media/logodefault.e65b27ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/logodefault.svg
// module id = 122
// module chunks = 0